import { Tooltip, Icon } from 'components/common';
import { theme } from 'utils/theme';

export const KeywordPaneInfoTooltip = () => (
  <Tooltip
    placement='left'
    title='Use this area to manage keywords of interest'
  >
    <div style={{ marginBottom: 4 }}>
      <Icon icon='help' size='sm' color={theme.teal} />
    </div>
  </Tooltip>
);
